import { IDistrict, IMunicipality, IMunicipalityDistrict } from "../models/IMunicipalityDistrict";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class MunicipalityDistrictApi extends ApiClient {
    
    getMunicipality(success: (data: IMunicipality) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/municipalityDistricts/getMunicipality`, success, error, final);
    }

    getDistrict(success: (data: IDistrict) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/municipalityDistricts/getDistrict`, success, error, final);
    }

    getTitles(success: (data: string[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get(`${Utils.MEN_PORTAL_API_BASE_URL}/municipalityDistricts/getTitles`, success, error, final);
    }
}

